module.exports = __webpack_public_path__ + "img/indicatorsEpc.c57876fd.svg";